import { AutogenModelFactoringService, AutogenRowFactoringService } from "./autogen/AutogenModelFactoringService";

export class ModelFactoringService extends AutogenModelFactoringService<RowFactoringService> {
	constructor() {
		super(RowFactoringService);
	}
}

export class RowFactoringService extends AutogenRowFactoringService {
}